import { getAuthAxiosBackend } from "../helpers/axios"

class ImageServices{

    constructor(){
    }

    get(id){
        return getAuthAxiosBackend().get( 'images' + '/' + id.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('images', {params: data})
    }

    add(image){
        return getAuthAxiosBackend().post('images', image)
    }

    edit(id, image){
        image.append('_method', 'put')
        return getAuthAxiosBackend().post('images' + '/' + id, image)
    }

    delete(id){
        return getAuthAxiosBackend().delete('images' + '/' + id)
    }
}

export default new ImageServices()